import { useMemo } from "react";
import { motion } from "framer-motion";
import { SlotSymbol } from "./SlotSymbol";

export const CELL = 84;

export const Reel = ({ final, prev, spinId, index, highlight, symbols, onDone }) => {
  const strip = useMemo(() => {
    if (!spinId) return final;
    const filler = Array.from({ length: 16 + index * 5 }, () => symbols[Math.floor(Math.random() * symbols.length)]);
    return [...final, ...filler, ...prev];
  }, [spinId]); // eslint-disable-line react-hooks/exhaustive-deps

  const dist = (strip.length - 3) * CELL;

  return (
    <div className="relative overflow-hidden flex-1 min-w-0 rounded-lg reel-bg" style={{ height: CELL * 3 }} data-testid={`reel-${index}`}>
      <motion.div
        key={spinId}
        initial={{ y: -dist, filter: spinId ? "blur(3px)" : "blur(0px)" }}
        animate={{ y: 0, filter: "blur(0px)" }}
        transition={{ duration: spinId ? 1 + index * 0.28 : 0, ease: [0.12, 0.62, 0.22, 1.06] }}
        onAnimationComplete={() => spinId && onDone(index)}
      >
        {strip.map((s, i) => (
          <div key={i} style={{ height: CELL }} className={`flex items-center justify-center ${i < 3 && highlight.has(i) ? "win-cell" : ""}`}>
            <SlotSymbol name={s} />
          </div>
        ))}
      </motion.div>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-black/80 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-8 bg-gradient-to-t from-black/80 to-transparent" />
    </div>
  );
};
